import { Link } from 'react-router-dom';
function ListeServices({ image, titre, description, lien }){
    return (
        <div className="w-[90vw] max-w-[320px] h-auto pb-5 bg-white dark:bg-bleu-gris rounded-[5px] shadow-md hover:shadow-xl transition-shadow duration-300 flex flex-col">
            <img src={image} alt={titre} className="rounded-t-[5px] w-full h-[180px] object-cover" />
            <div className="flex flex-col items-center justify-between gap-4 px-4 py-6 flex-1">
                <h3 className="text-gris-sombre dark:text-fond-sombre text-2xl font-bold text-center">{titre}</h3>
                <p className="text-gris-sombre dark:text-fond-sombre text-[13px] font-normal text-center line-clamp-3">{description}</p>
                <Link
                    to={lien}
                    className="mt-2 px-5 py-2 bg-bleu-je text-white text-sm font-semibold rounded-[4px] hover:bg-blue-700 transition-colors duration-200"
                >
                    En savoir plus
                </Link>
            </div>
        </div>
    );
}
export default ListeServices;